import React, { useState } from 'react'
import data from '../data/timeline'
import '../css/routes.css'

const Routes = () => {
  // eslint-disable-next-line
  const [routes, setRoutes] = useState(data)

  return (
    <>
      <section className="bg-gray-900 pt-32">
        <h1 className="font-bold text-center text-white text-4xl lg:text-6xl">
          Routes
        </h1>
        {routes.map((route) => {
          const { id, text } = route

          return (
            <div className="timeline pb-2" key={id}>
              <div className="container right">
                <div className="content">
                  <p className="font-bold text-xl">{text}</p>
                </div>
              </div>
            </div>
          )
        })}
      </section>
    </>
  )
}

export default Routes
